import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

/**
 * DİL TERCİHİ — TEK KAYNAK.
 *
 * Kural (Selçuk):
 *   1. localStorage'da kayıtlı bir tercih VARSA her zaman o kullanılır.
 *      Kullanıcının kendi seçimi tarayıcı ayarını daima yener.
 *   2. Kayıt YOKSA tarayıcının dili okunur: Türkçe ise 'tr', değilse 'en'.
 *   3. Kullanıcı dili değiştirdiği AN localStorage'a yazılır.
 *
 * 3. maddenin inceliği: tespit edilen dil kendiliğinden KAYDEDİLMEZ. Kayıt
 * yalnızca kullanıcı seçtiğinde yapılır. Aksi halde siteye bir kez giren
 * herkesin tercihi anında mühürlenirdi ve tarayıcı dilini sonradan Türkçeye
 * çeviren biri hiçbir zaman Türkçe göremezdi.
 */
export const DIL_ANAHTARI = 'whowsell-lang';
export const DESTEKLENEN_DILLER = ['tr', 'en'];

/** localStorage'daki tercih; yoksa ya da tanınmıyorsa null. */
export function kayitliDilTercihi() {
  if (typeof window === 'undefined') return null;
  try {
    const deger = window.localStorage.getItem(DIL_ANAHTARI);
    return DESTEKLENEN_DILLER.includes(deger) ? deger : null;
  } catch (e) {
    /* Gizli sekmede veya çerez engelliyken localStorage patlayabilir. */
    return null;
  }
}

/**
 * Tarayıcının bildirdiği dillerden desteklediğimiz ilkini seçer.
 * `navigator.languages` öncelik sırasındadır; ilk eşleşme kazanır.
 * Hiçbiri tutmazsa 'en'.
 */
export function tarayiciDili() {
  if (typeof navigator === 'undefined') return 'en';
  const adaylar = []
    .concat(navigator.languages || [])
    .concat([navigator.language, navigator.userLanguage])
    .filter(Boolean);
  for (const aday of adaylar) {
    const kok = String(aday).toLowerCase().split('-')[0];
    if (DESTEKLENEN_DILLER.includes(kok)) return kok;
  }
  return 'en';
}

/** İlk kare için geçerli dil: tercih > tarayıcı > 'en'. */
export function baslangicDili() {
  return kayitliDilTercihi() || tarayiciDili();
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(baslangicDili);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  /* Yalnızca kullanıcı seçtiğinde yazılır — bkz. yukarıdaki 3. madde. */
  const setLang = (yeni) => {
    if (!DESTEKLENEN_DILLER.includes(yeni)) return;
    try {
      window.localStorage.setItem(DIL_ANAHTARI, yeni);
    } catch (e) {
      /* Yazamazsak tercih bu oturumda geçerli olur, uygulama çalışmaya devam eder. */
    }
    setLangState(yeni);
  };

  const toggleLang = () => setLang(lang === 'tr' ? 'en' : 'tr');

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used within LanguageProvider');
  return ctx;
}
